import React from 'react';
import { Row, Col, Input, Form, Button, Select } from 'antd';
import { QuestionCircleOutlined, DollarCircleFilled } from '@ant-design/icons';

import SpanComponent from '@sharedComponent/span-component';
import Header from '@sharedComponent/header/header';
import { constructTrackingStrings } from '@helpers';
import TrackingStrings from '@sharedComponent/tracking-strings';

const { Option } = Select;

const CommissionInput = ({ label, name, handleChange, hideInfo = false }) => (
	<Col xl={8} md={12} sm={12} xs={12} className="affiliate_commission_box">
		<Col>
			<Col>
				<SpanComponent className="commission_text">{label}</SpanComponent>
				{!hideInfo && <QuestionCircleOutlined className="commission_icon" />}
			</Col>
			<Col className="commission_input">
				<Input name={name} onChange={handleChange} prefix={<DollarCircleFilled className="site-form-item-icon" />} />
			</Col>
		</Col>
	</Col>
);

const ValueInput = ({ label, name, handleChange }) => (
	<Col xl={8} md={12} sm={24} xs={24} className="value_box">
		<Row className="value_input" align="middle" justify="center">
			<Col className="value">
				<SpanComponent>{label}</SpanComponent>
			</Col>
			<Col className="input_class">
				<Input name={name} onChange={handleChange} />
			</Col>
		</Row>
	</Col>
);

const AddAffiliatePresentational = ({
	addAffiliateLoading,
	affiliate: { userName, email, sourceValue1, sourceValue2, sourceValue3, sourceValue4, sourceValue5 },
	history,
	handleChange,
	handleAdd,
	userDetails,
	campaignDDList = [],
	campaignDDListLoading = false,
	handleDropdownChange,
}) => {
	const [formRef] = Form.useForm();
	// const header = type === 'add' ? 'Add' : 'Edit';
	// const titleText = type === 'add' ? 'ADD NEW' : 'EDIT';
	let trackingStrings = null;
	trackingStrings = constructTrackingStrings({ sourceValue1, sourceValue2, sourceValue3, sourceValue4, sourceValue5 });
	return (
		<Row className="campaign_container">
			<Col xl={24}>
				<Header title="Affiliate Management / Create New Affiliate" hideAddAffiliate />
			</Col>
			<Col xl={24}>
				<Col xl={24} className="campaign_container_box">
					<Col xl={24} className="campaign_container_title">
						<SpanComponent className="campaign_container_title_text">Create New Affiliate</SpanComponent>
					</Col>
					<Form onFinish={handleAdd} layout="vertical" hideRequiredMark={false} style={{ width: '100%' }}>
						<Col xl={24} className="campaign_container_body">
							<Row>
								<Col xl={11} lg={11} md={24} sm={24} xs={24}>
									<Form.Item
										rules={[
											{
												required: true,
												message: 'Affiliate name is required!',
											},
										]}
										className="full_border"
										name="title"
										label="Title">
										<Input name="userName" onChange={handleChange} />
									</Form.Item>
								</Col>
								<Col xl={2} lg={2}></Col>
								<Col xl={11} lg={11} md={24} sm={24} xs={24}>
									<Form.Item
										className="noreq"
										rules={[
											{
												required: true,
												message: 'Email is required!',
											},
											{
												type: 'email',
												message: 'Please input a valid email (Ex: abc@example.com)',
											},
										]}
										className="full_border"
										name="email"
										label="Email">
										<Input name="email" onChange={handleChange} />
									</Form.Item>
								</Col>
								<Col xl={11} lg={11} md={24} sm={24} xs={24}>
									<Form.Item className="full_border" name="affiliateId" label="Affiliate ID">
										<Input disabled />
									</Form.Item>
								</Col>
								<Col xl={2} lg={2}></Col>
								<Col xl={11} lg={11} md={24} sm={24} xs={24}>
									<Form.Item className="full_border" name="domain" label="Domain">
										<Input disabled />
									</Form.Item>
								</Col>
								<Col xl={11} lg={11} md={24} sm={24} xs={24}>
									<Form.Item
										rules={[
											{
												required: false,
												message: 'Campaigns are required!',
											},
										]}
										className="full_border"
										name="Campaigns"
										label="Campaigns">
										<Select
											maxTagCount={2}
											className="add_affiliate_select"
											mode="tags"
											placeholder="Select a Campaign"
											onChange={handleDropdownChange}
											loading={campaignDDListLoading}>
											{campaignDDList.map((campaign) => (
												<Option value={campaign.campaignId}>{campaign.campaignName}</Option>
											))}
										</Select>
									</Form.Item>
								</Col>
							</Row>
							<Row className="value_container" align="middle">
								<ValueInput label="Value 1:" name="sourceValue1" handleChange={handleChange} />
								<ValueInput label="Value 2:" name="sourceValue2" handleChange={handleChange} />
								<ValueInput label="Value 3:" name="sourceValue3" handleChange={handleChange} />
								<ValueInput label="Value 4:" name="sourceValue4" handleChange={handleChange} />
								<ValueInput label="Value 5:" name="sourceValue5" handleChange={handleChange} />
							</Row>
							<TrackingStrings value={`${(userDetails && userDetails.businessUrl) || ''}affid=""${trackingStrings}`} isAff />
							<Row className="affiliate_commission" align={'bottom'}>
								<Col xl={24}>
									<SpanComponent className="affiliate_commission_title">Affiliate Commission</SpanComponent>
								</Col>
								<Col xl={12} lg={20} md={24} sm={24} xs={24} className="affiliate_commission_container">
									<Row>
										<CommissionInput label="Commission" name="cpcCommission" handleChange={handleChange} />
										<CommissionInput label="Step 1" name="step1Commission" handleChange={handleChange} />
										<CommissionInput label="Step 2" name="step2Commission" handleChange={handleChange} />
									</Row>
								</Col>
								<Col xl={24}>
									<Row justify="end">
										<Col xl={12} lg={12} md={24} sm={24} xs={24}>
											<Row style={{}} justify="end">
												<Col xl={8} lg={11} md={24} sm={24} xs={24} style={{ marginTop: '5px', marginRight: 10 }}>
													<Button
														style={{
															fontSize: 13,
															height: 50,
														}}
														className="ant_cancel_btn"
														onClick={() => history.goBack()}>
														Cancel
													</Button>
												</Col>
												<Col xl={8} lg={11} md={24} sm={24} xs={24} style={{ marginTop: '5px' }}>
													<Button
														htmlType="submit"
														loading={addAffiliateLoading}
														disabled={!(userName && email)}
														style={{
															fontSize: 13,
															height: 50,
														}}
														className="ant_submit_btn">
														Send Invitation email
													</Button>
												</Col>
											</Row>
										</Col>
									</Row>
								</Col>
							</Row>
						</Col>
					</Form>
				</Col>
			</Col>
		</Row>
	);
};

export default AddAffiliatePresentational;
